import styled from 'styled-components';
import TransparentButton from '@/trio-ui/TransparentButton';

export const CustomTransparentButton = styled(TransparentButton)<{ withMarginTop?: boolean }>`
  margin-top: ${(props) => (props.withMarginTop ? '-8px' : '2px')};
  margin-left: 10px;
`;

export const AddFilters = styled.button<{ withMarginTop?: boolean }>`
  font-size: 14px;
  line-height: 21px;
  height: 32px;
  padding: 5px 12px;
  border-radius: 2px;
  color: ${(props) => props.theme.colors['primary-60']};
  margin-left: 8px;
  margin-top: ${(props) => (props.withMarginTop ? '-8px' : '2px')};
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-left: 20px;
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
  &:hover {
    background-color: ${(props) => props.theme.colors['neutral-30']};
  }
`;

export const Text = styled.p`
  font-size: 14px;
  line-height: 21px;
  margin-right: 20px;
  height: 36px;
  align-items: center;
  display: flex;
`;

export const Box = styled.div`
  display: flex;
  margin-bottom: 32px;
  align-items: start;
  z-index: 1;
  position: relative;
  border-top: 1px solid;
  border-color: ${(props) => props.theme.colors['neutral-40']};
  padding-top: 16px;
`;

export const FiltersArea = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;
